import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ScrollText } from "lucide-react";

const COLOR = {
  login: "bg-slate-100 text-slate-700", payment_completed: "bg-emerald-100 text-emerald-800",
  payment_initiated: "bg-amber-100 text-amber-800", twin_run_triggered: "bg-blue-100 text-blue-800",
  prospect_generated: "bg-blue-100 text-blue-800", email_sent: "bg-indigo-100 text-indigo-800",
  prospect_voicemail_sent: "bg-purple-100 text-purple-800", dnc_request: "bg-red-100 text-red-800",
  api_error: "bg-red-100 text-red-800", account_creation: "bg-emerald-100 text-emerald-800",
  administrator_setting_change: "bg-slate-100 text-slate-700",
};

export default function AdminAudit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setRows(r.data)); }, []);

  return (
    <div>
      <PageHeader title="Audit Log" subtitle="Immutable record of key platform events." />
      <Card className="divide-y divide-slate-100">
        {rows.length === 0 && <div className="p-10 text-center text-sm text-slate-400"><ScrollText className="mx-auto mb-2 h-8 w-8 text-slate-300" />No audit events yet.</div>}
        {rows.map((r) => (
          <div key={r.id} className="flex items-start justify-between gap-3 p-4" data-testid={`audit-${r.id}`}>
            <div className="min-w-0">
              <div className="flex flex-wrap items-center gap-2">
                <Badge className={`${COLOR[r.action] || "bg-slate-100 text-slate-700"} border-0 capitalize`}>{r.action.replace(/_/g, " ")}</Badge>
                <span className="text-sm text-slate-700">{r.actor_email}</span>
              </div>
              {r.detail && <p className="mt-1 text-xs text-slate-500">{r.entity_type} · {r.detail}</p>}
            </div>
            <span className="shrink-0 text-[11px] text-slate-400">{new Date(r.created_at).toLocaleString()}</span>
          </div>
        ))}
      </Card>
    </div>
  );
}
